import { Card, CardContent, makeStyles, MenuItem, Select, Typography } from '@material-ui/core'

import React from 'react'
import LineChartdata from '../../chartsData/LineChartdata'
import { months } from '../../shared/data'
import { Line } from 'react-chartjs-2'
import CustomHeading from '../CustomHeading'
import Loader from '../Loader'
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
    // boxShadow:'none'
    height: '213px',
  },
  icon: {
    width: '22px',
    height: '22px',
    cursor: 'pointer',
    marginLeft: '22px',
    // marginTop: '4px',
  },
  icons: {
    marginLeft: '20px',
    cursor: 'pointer',
  },

  subtitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: ' 38px',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
  },
  title1: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
    paddingBottom: '43px',
  },

  title2: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    margin: 5,

    color: '#313131',
  },
  title3: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',

    color: '#313131',
    paddingBottom: '10px',
  },
  title4: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
    paddingBottom: '9px',
  },
  image: {
    // borderRadius: '45%',
    // height: '9%',
    width: '45px',
    height: '45px',
  },
  underline: {
    borderTop: '1px solid  #CCCCCC',
  },
  drop: {
    width: '70px',
    backgroundColor: 'white',
    border: 'none',
    display: 'flex',
    justifyContent: 'center',
  },
  srollbar: {
    height: '580px',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '0.3em',
      borderRadius: '2px',
    },
    // '&::-webkit-scrollbar-track': {
    //   boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    //   webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    // },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'slategrey',
      // outline: '1px solid slategrey',
    },
  },
}))

export default function AbsentChart({ monthlyAbsent }) {
  const classes = useStyles()

  //console.log('CHECKS : ', monthlyAbsent)
  var myData =
    monthlyAbsent &&
    Object.keys(monthlyAbsent).map((key) => {
      return monthlyAbsent[key]
    })

  // //console.log('MYH DATA : ', myData)

  const totalAbsentInMonth = (canvas) => {
    const ctx = canvas.getContext('2d')
    const gradient1 = ctx.createLinearGradient(10, 10, 255, 1)
    gradient1.addColorStop(0, ' lightblue')
    gradient1.addColorStop(1, '#F5F8FF')
    return {
      labels: months,
      datasets: [
        {
          label: 'Attendance',
          data: myData,
          pointRadius: 0,
          borderColor: 'rgb(75, 192, 192)',
          backgroundColor: gradient1,
          tension: 0.4,
          fill: true,
        },
      ],
    }
  }

  return (
    // <Card variant="outlined" className={classes.root}>
    <>
      {monthlyAbsent ? (
        <div style={{ display: 'flex', justifyContent: 'center', height: '130px' }}>
          <Line data={totalAbsentInMonth} options={LineChartdata.Linedataoptions} />
        </div>
      ) : (
        <Loader />
      )}
      {monthlyAbsent && monthlyAbsent.length === 0 && (
        <div style={{ marginLeft: '90px', marginTop: '50px' }}>
          <CustomHeading heading="No Attendance Found" className={classes.title3} />
        </div>
      )}
    </>
    // </Card>
  )
}
